module.exports = __webpack_public_path__ + "img/logo-2-en.3c1a3b5b.png";